import { baseColors, Colors } from './baseColors';

export const framedChalkColors: Colors = {
    ...baseColors,
};
